var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponseSetGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_11765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 20H6.66667C5.19391 20 4 21.1939 4 22.6667V25.3333C4 26.8061 5.19391 28 6.66667 28H9.33333C10.8061 28 12 26.8061 12 25.3333V22.6667C12 21.1939 10.8061 20 9.33333 20Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 20H22.6667C21.1939 20 20 21.1939 20 22.6667V25.3333C20 26.8061 21.1939 28 22.6667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V22.6667C28 21.1939 26.8061 20 25.3333 20Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4H14.6667C13.1939 4 12 5.19391 12 6.66667V9.33333C12 10.8061 13.1939 12 14.6667 12H17.3333C18.8061 12 20 10.8061 20 9.33333V6.66667C20 5.19391 18.8061 4 17.3333 4Z",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20V18.6667C8 17.9594 8.28095 17.2811 8.78105 16.781C9.28115 16.281 9.95942 16 10.6667 16H21.3333C22.0406 16 22.7189 16.281 23.219 16.781C23.719 17.2811 24 17.9594 24 18.6667V20",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12V16",
    stroke: "#38CB89",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_11765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseSetGreen);
export default __webpack_public_path__ + "static/media/response-set-green.c5ed99b82cc750fd9657feef6fce215c.svg";
export { ForwardRef as ReactComponent };